export const FIND_ALL_SUBACCESSORIES_REQUEST = "FIND_ALL_SUBACCESSORIES_REQUEST";
export const FIND_ALL_SUBACCESSORIES_SUCCESS = "FIND_ALL_SUBACCESSORIES_SUCCESS";
export const FIND_ALL_SUBACCESSORIES_FAIL = "FIND_ALL_SUBACCESSORIES_FAIL";

export const FIND_SINGLE_SUBACCESSORIES_REQUEST = "FIND_SINGLE_SUBACCESSORIES_REQUEST";
export const FIND_SINGLE_SUBACCESSORIES_SUCCESS = "FIND_SINGLE_SUBACCESSORIES_SUCCESS";
export const FIND_SINGLE_SUBACCESSORIES_FAIL = "FIND_SINGLE_SUBACCESSORIES_FAIL";

